import styled from "styled-components";

export const StyledRowValues = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
`;
